import React from 'react';
import PropTypes from 'prop-types';

const StraightFace = ({ className, color, size }) => (
    <svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M17 24C18.6562 24 20 22.6562 20 21C20 19.3438 18.6562 18 17 18C15.3438 18 14 19.3438 14 21C14 22.6562 15.3438 24 17 24Z"
            fill={color}
        />
        <path
            d="M31 24C32.6562 24 34 22.6562 34 21C34 19.3438 32.6562 18 31 18C29.3438 18 28 19.3438 28 21C28 22.6562 29.3438 24 31 24Z"
            fill={color}
        />
        <path d="M14 28V32H34V28H14Z" fill={color} />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24 44C35.0469 44 44 35.0469 44 24C44 12.9531 35.0469 4 24 4C12.9531 4 4 12.9531 4 24C4 35.0469 12.9531 44 24 44ZM24 40C32.8359 40 40 32.8359 40 24C40 15.1641 32.8359 8 24 8C15.1641 8 8 15.1641 8 24C8 32.8359 15.1641 40 24 40Z"
            fill={color}
        />
    </svg>
);

StraightFace.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string.isRequired,
    size: PropTypes.number,
};

StraightFace.defaultProps = {
    size: 48,
    className: '',
};

export default StraightFace;
